import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaChalkboardTeacher,
  FaUserTie,
  FaLaptopCode,
  FaChartLine,
  FaUsersCog,
} from "react-icons/fa";
import "../assets/css/home.css";
import { FaBookOpen, FaBriefcase, FaLayerGroup, FaUsers } from 'react-icons/fa';
import hero1 from "../assets/bg-traing.jpg";
import AboutImage from "../assets/about-traing.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
// Client logos
import img1 from "../assets/our-p.jpg";
import img2 from "../assets/our-p2.jpg";
import img3 from "../assets/our-p3.png";
import img4 from "../assets/our-p4.jpg";
import img5 from "../assets/our-p5.png";
import img6 from "../assets/our-p6.png";
import img7 from "../assets/our-p7.png";
import img8 from "../assets/our-p10.png";
import img9 from "../assets/our-p9.png";

// Add more logos as needed
const clients = [img1, img2, img3,img4,  img5, img6, img7,img8, img9];

const TowersTraining = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const services = [
    {
      title: "Instructor-Led Training",
      icon: <FaChalkboardTeacher />,
      desc: [
        "Domain-specific technical programs (IT, Banking, Finance, Health & Safety, Oil & Gas)",
        "Preparatory Courses for Certifications",
        "Business Essentials",
        "Leadership Development",
      ],
    },
    {
      title: "Executive Coaching",
      icon: <FaUserTie />,
      desc: [
        "One-on-one Coaching",
        "Team Coaching",
        "Mentoring",
        "Coach Training",
      ],
    },
    {
      title: "E-Learning Solutions",
      icon: <FaLaptopCode />,
      desc: [
        "Custom E-learning Modules",
        "Webinars & Virtual Workshops",
        "Blended Learning Programs",
        "Learning Management System (LMS) Support",
      ],
    },
    {
      title: "Talent Assessments",
      icon: <FaChartLine />,
      desc: [
        "Pre-hiring Assessments",
        "Assessment Centers for Development",
        "Leadership & Team Assessments",
      ],
    },
    {
      title: "HR & Organizational Consultancy",
      icon: <FaUsersCog />,
      desc: [
        "Talent Acquisition & Workforce Planning",
        "Competency Framework Design",
        "Employee Engagement & Culture Surveys",
        "Team Building & Organizational Development",
        "Talent Management & Succession Planning",
      ],
    },
  ];

  return (
     <div>
           {/* Hero Section */}
      <div className="container-fluid p-0">
<div
  className="hero-section"
  style={{ backgroundImage: `url(${hero1})` }}
>
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <p className="text-uppercase text-light m-0">Learn. Grow. Achieve.</p>
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                Towers Training
              </h1>
            </div>
          </div>
        </div>
      </div>
   <section className="py-5 bg-white">
      <div className="container">
        <div className="row align-items-center g-4">

          {/* Left: Image with Badge */}
          <div className="col-md-6 position-relative" data-aos="fade-up">
            <img
              src={AboutImage}
              alt="About Towers Training"
              className="img-fluid rounded-3 shadow"
            />
          </div>

          {/* Right: Content */}
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
            <span className="text-danger fs-4 mb-2 fw-bold">About Us</span>
            <p className="fs-5">
              Towers Training is a premier provider of human capital management solutions, committed to enabling individuals and organizations to unlock their full potential. We aim to be the leading catalyst for building a future-ready workforce, driving a competitive and knowledge-based economy in line with Oman’s Vision 2040.
            </p>

            <ul className="list-unstyled mb-3">
              <li className="mb-1 fs-5">• Seasoned professionals with diverse industry experience</li>
              <li className="mb-1 fs-5">• Network of trainers, coaches, assessors, instructional designers, consultants, and subject matter experts</li>
              <li className="mb-1 fs-5">• Blend of regional insight with global expertise</li>
            </ul>
          </div>

        </div>
      </div>
    </section>

         {/* <WhyPartner /> */}
           <div className="container pb-4">
        {/* Towers Training Section */}
        <section className="p-4">
          <div className="text-center mb-5" data-aos="fade-up">
            <h3 className="fw-bold">Towers Training</h3>
            <p className="text-muted">
              Empowering individuals and organizations through tailored human capital development programs.
            </p>
          </div>

          <div className="row g-4">
            <div className="col-md-3" data-aos="zoom-in" data-aos-delay="100">
              <div className="card h-100 border-0 shadow-sm text-center p-3">
                <div className="mb-3 text-primary fs-1">
                  <FaBookOpen />
                </div>
                <h5 className="fw-bold">Knowledge</h5>
                <p className="text-muted">
                  Building workforce capabilities aligned with Oman’s Vision 2040 for a knowledge-based economy.
                </p>
              </div>
            </div>

            <div className="col-md-3" data-aos="zoom-in" data-aos-delay="200">
              <div className="card h-100 border-0 shadow-sm text-center p-3">
                <div className="mb-3 text-success fs-1">
                  <FaBriefcase />
                </div>
                <h5 className="fw-bold">Professional Growth</h5>
                <p className="text-muted">
                  Delivering customized corporate and investment banking, Islamic finance, and service excellence programs.
                </p>
              </div>
            </div>

            <div className="col-md-3" data-aos="zoom-in" data-aos-delay="300">
              <div className="card h-100 border-0 shadow-sm text-center p-3">
                <div className="mb-3 text-danger fs-1">
                  <FaUsers />
                </div>
                <h5 className="fw-bold">Human Empowerment</h5>
                <p className="text-muted">
                  Enabling individuals and institutions to unlock their full potential through structured learning paths.
                </p>
              </div>
            </div>

            <div className="col-md-3" data-aos="zoom-in" data-aos-delay="400">
              <div className="card h-100 border-0 shadow-sm text-center p-3">
                <div className="mb-3 text-warning fs-1">
                  <FaLayerGroup />
                </div>
                <h5 className="fw-bold">Integration</h5>
                <p className="text-muted">
                  Combining local insights and global standards to deliver impactful, sustainable training outcomes.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    <section className="services-section py-5">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold text-dark">Our Services</h2>
          <p className="text-muted">
            Strategic development solutions across five core areas.
          </p>
        </div>

        <div className="row g-4">
          {services.map((srv, index) => (
            <div
              key={index}
              className="col-12 col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)}
            >
              <div className="service-card-pro h-100 p-4 rounded-4 border bg-white shadow-sm">
                <div className="d-flex align-items-center mb-3">
                  <div className="icon-wrapper me-3">{srv.icon}</div>
                  <h5 className="fw-semibold mb-0 text-dark">{srv.title}</h5>
                </div>
                <ul className="list-unstyled text-muted fs-6 mb-0 ps-1">
                  {srv.desc.map((point, i) => (
                    <li key={i} className="d-flex align-items-start mb-2">
                      <span className="bullet me-2">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-3 text-center pb-4" data-aos="fade-up">
      <div className="container-fluid">
        <h3 className="fw-bold mb-2">Our Partners</h3>
        <p className="text-muted mb-4 client-para">Proudly partnering with leading organizations to drive excellence and innovation together.
        </p>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={2}
          loop={true}
          autoplay={{ delay: 2000 }}
          breakpoints={{
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
            1200: { slidesPerView: 6 },
          }}
        >
          {clients.map((logo, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={logo}
                alt={`Client ${idx}`}
                className="img-fluid p-2"
                style={{ height: "100px", objectFit: "contain" }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
     </div>
  );
};

export default TowersTraining;
